<!--div class="tooltipComponent" [style.left]="left + 'px'" [style.top]="top + 'px'">
     <div class="left" [innerHTML]="tooltip"></div>
     <i></i>
</div-->
     
<div class="newToolTipComponent" [innerHTML]="tooltip|safe">

</div>
     